import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useSearchParams } from "react-router-dom";

/* eslint-disable react/prop-types */
function TicketCard({ ticket }) {
    const { addToCart, cartItems } = useContext(CartContext);
    const [searchParams] = useSearchParams();
    const isPrivate = searchParams.get("private") === "true";
    const MIN_QUANTITY = isPrivate ? 2 : 6;

    const handleChange = (event) => {
        const quantity = Number(event.target.value);
        const newItem = { ...ticket, quantity };
        addToCart(newItem);
    };
    const searchOnLocalCart = () => {
        const item = cartItems.find((item) => item.id === ticket.id);
        return item ? item.quantity : 0;
    };

    return (
        <div className="flex gap-2 p-4 items-center justify-between w-full m-2 rounded-sm font-sans">
            <div className="flex gap-4 align-baseline flex-1">
                <img
                    className="h-10 w-10 object-cover rounded-full m-0 p-0 hidden sm:block"
                    src={ticket.img}
                    alt="sin imagen"
                />
                <div className="flex-auto">
                    <div className="flex items-center gap-2">
                        <p className="text-lg">{ticket.categoria}</p>
                        {(ticket.multiplier || 1) > 1 && (
                            <span className="rounded-full border border-yellow-cdg/50 bg-yellow-cdg/10 px-2 py-0.5 text-[11px] font-semibold text-yellow-cdg">
                                {(ticket.multiplier || 1)}x
                            </span>
                        )}
                    </div>
                    <p className="text-sm text-gray-400 max-w-sm">
                        {ticket.descripcion}{" "}
                    </p>
                </div>
            </div>
            <p className="mr-3 flex-auto text-center">${ticket.precio}</p>
            {ticket.stock > 0 ? (
                <div className="flex sm:flex-auto justify-end">
                    <select
                        className="text-black rounded-sm w-14 text-center"
                        onChange={handleChange}
                        value={searchOnLocalCart()}
                    >
                        {Array.from(
                            {
                                length: Math.min(
                                    ticket.stock + 1,
                                    MIN_QUANTITY
                                ),
                            },
                            (_, i) => (
                                <option key={i} value={i}>
                                    {i}
                                </option>
                            )
                        )}
                    </select>
                </div>
            ) : (
                <div className="flex sm:flex-auto justify-end">
                    <button className="bg-gray-600 p-2 rounded-lg text-gray-400">
                        {ticket.estado}
                    </button>
                </div>
            )}
        </div>
    );
}

export default TicketCard;
